import { Badge } from '@shared/components';

interface Props {
    date: string;
    overdue: boolean;
    className?: string;
}

export function DueDateLabel({ date, overdue, className = 'inline-flex text-xs' }: Props) {
    return (
        <span className={`${className} items-center gap-2 text-mp-muted`}>
            {date}
            {overdue && <Badge variant="error">Overdue</Badge>}
        </span>
    );
}
